module.exports = __webpack_public_path__ + "img/Antonio-Jose-Castro-Hernandez.6aaffc96.png";